/**
 * Created by Ivan Morozov on 20.10.2026
 */

const DisabledProducts = {
    initialize: function () {
        this.list = cleverapps.PageSession.get("disabledProducts") || [];

        const getProduct = connector.payments.getProduct.bind(connector.payments);
        connector.payments.getProduct = function (productIdOrTag) {
            const product = getProduct(productIdOrTag);
            return product && DisabledProducts.isDisabled(product.itemId) ? undefined : product;
        };
    },

    isDisabled: function (itemId) {
        return this.list.includes(itemId);
    },

    toggle: function (itemId) {
        if (this.isDisabled(itemId)) {
            this.list.splice(this.list.indexOf(itemId), 1);
        } else {
            this.list.push(itemId);
        }

        cleverapps.PageSession.set("disabledProducts", this.list);
        cleverapps.offerManager.refreshAll();
    }
};
